import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'wen-icon-share',
  templateUrl: './share.component.html',
  styleUrls: ['./share.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ShareIconComponent {}
